module.exports = __webpack_public_path__ + "static/gamescreenshot-a14a5132b086e355fe845d06a9781916.png";